import { cn } from "@/lib/utils";
import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  className?: string;
  fill?: string;
};

export function ArrowRight({ className, fill, ...props }: Props) {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("rtl:rotate-180", className)}
      {...props}
    >
      <g opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0963 8.94538C16.7146 9.56371 16.7146 10.5662 16.0963 11.1846L11.9061 15.3748C11.5969 15.6839 11.0957 15.6839 10.7865 15.3748C10.4774 15.0656 10.4774 14.5644 10.7865 14.2552L14.185 10.8566H3.23173C2.7945 10.8566 2.44006 10.5022 2.44006 10.065C2.44006 9.62776 2.7945 9.27332 3.23173 9.27332H14.1851L10.7865 5.87478C10.4774 5.56561 10.4774 5.06436 10.7865 4.75519C11.0957 4.44602 11.5969 4.44602 11.9061 4.75519L16.0963 8.94538L15.5977 9.44395L16.0963 8.94538Z"
          fill={fill ?? "#FFF4E3"}
        />
      </g>
    </svg>
  );
}

export function ArrowLeft({ className, fill, ...props }: Props) {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("rotate-180 rtl:rotate-0", className)}
      {...props}
    >
      <g opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0963 8.94538C16.7146 9.56371 16.7146 10.5662 16.0963 11.1846L11.9061 15.3748C11.5969 15.6839 11.0957 15.6839 10.7865 15.3748C10.4774 15.0656 10.4774 14.5644 10.7865 14.2552L14.185 10.8566H3.23173C2.7945 10.8566 2.44006 10.5022 2.44006 10.065C2.44006 9.62776 2.7945 9.27332 3.23173 9.27332H14.1851L10.7865 5.87478C10.4774 5.56561 10.4774 5.06436 10.7865 4.75519C11.0957 4.44602 11.5969 4.44602 11.9061 4.75519L16.0963 8.94538L15.5977 9.44395L16.0963 8.94538Z"
          fill={fill ?? "#FFF4E3"}
        />
      </g>
    </svg>
  );
}

export function ArrowDown({ className, fill, ...props }: Props) {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("rotate-90", className)}
      {...props}
    >
      <g opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0963 8.94538C16.7146 9.56371 16.7146 10.5662 16.0963 11.1846L11.9061 15.3748C11.5969 15.6839 11.0957 15.6839 10.7865 15.3748C10.4774 15.0656 10.4774 14.5644 10.7865 14.2552L14.185 10.8566H3.23173C2.7945 10.8566 2.44006 10.5022 2.44006 10.065C2.44006 9.62776 2.7945 9.27332 3.23173 9.27332H14.1851L10.7865 5.87478C10.4774 5.56561 10.4774 5.06436 10.7865 4.75519C11.0957 4.44602 11.5969 4.44602 11.9061 4.75519L16.0963 8.94538L15.5977 9.44395L16.0963 8.94538Z"
          fill={fill ?? "#FFF4E3"}
        />
      </g>
    </svg>
  );
}

export function ArrowTop({ className, fill, ...props }: Props) {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("-rotate-90", className)}
      {...props}
    >
      <g opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0963 8.94538C16.7146 9.56371 16.7146 10.5662 16.0963 11.1846L11.9061 15.3748C11.5969 15.6839 11.0957 15.6839 10.7865 15.3748C10.4774 15.0656 10.4774 14.5644 10.7865 14.2552L14.185 10.8566H3.23173C2.7945 10.8566 2.44006 10.5022 2.44006 10.065C2.44006 9.62776 2.7945 9.27332 3.23173 9.27332H14.1851L10.7865 5.87478C10.4774 5.56561 10.4774 5.06436 10.7865 4.75519C11.0957 4.44602 11.5969 4.44602 11.9061 4.75519L16.0963 8.94538L15.5977 9.44395L16.0963 8.94538Z"
          fill={fill ?? "#FFF4E3"}
        />
      </g>
    </svg>
  );
}
